import produce from 'immer';
import { ActionTypes } from './Popup.actions';

export const initialState = {
    displaySystemNotificationPopup: null,
};
const reducer = (state = initialState, action) => produce(state, (draft) => {
    switch (action.type) {
        case ActionTypes.fetchSystemNotificationCompleted: {
            const { displaySystemNotificationPopup } = action.payload;
            draft.displaySystemNotificationPopup = displaySystemNotificationPopup;
            return draft;
        }
        case ActionTypes.updateSystemNotificationCompleted: {
            draft.displaySystemNotificationPopup = false;
            return draft;
        }
        default: {
            return state;
        }
    }
});
export default reducer;
